var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBhtVdeadline = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.7136,
    cy: 15.1108,
    rx: 15.4886,
    ry: 15.1108,
    fill: "#F5C316"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1724_48212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66244 15.1119L6.66244 15.475H7.02545H8.68764H9.05066V15.1119C9.05066 13.4672 9.69536 11.8879 10.8464 10.713C11.9975 9.53811 13.5632 8.8612 15.2077 8.82751L15.5706 8.82008L15.5632 8.45714L15.5291 6.7953L15.5217 6.43236L15.1588 6.4398C12.8895 6.48628 10.7289 7.42037 9.1405 9.04165C7.55209 10.6629 6.66244 12.8422 6.66244 15.1119Z",
    stroke: "white",
    strokeWidth: 0.726028
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.7142,
    y: 15.4893,
    width: 0.755541,
    height: 0.755541,
    rx: 0.363014,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.0919,
    cy: 15.8672,
    r: 2.62964,
    stroke: "white",
    strokeWidth: 0.726028
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7446 20.891C14.9701 21.8037 11.981 20.2944 11.0682 17.5199C10.1555 14.7454 11.6648 11.7563 14.4393 10.8435C17.2138 9.93077 20.2029 11.44 21.1157 14.2146C22.0284 16.9891 20.5192 19.9782 17.7446 20.891Z",
    stroke: "white",
    strokeWidth: 0.726028,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.63 3.63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1724_48212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.133,
    height: 18.133,
    fill: "white",
    transform: "translate(6.2699 6.04492)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBhtVdeadline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/BHTVdeadline.cd7cba72.svg";
export { ForwardRef as ReactComponent };